import React from 'react'
import { useNavigate } from 'react-router-dom'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import {
  Box,
  Divider,
  Drawer,
  IconButton,
  Stack,
  TableCell,
  Typography
} from '@mui/material'
import SimpleTable from 'common/AbstractTable/SimpleTable'
import ColorBoxInfo from 'common/Box/ColorBoxInfo'
import { RoundedButton } from 'common/Button/Button'
import format from 'date-fns/format'
import { OrderGetDataBase } from 'types/api/v1/order.type'

interface OrderDrawerProps {
  drawerOpen: boolean
  handleClose: (value: void) => void
  selectedOrder: OrderGetDataBase
}

const ViewOrderDrawer = ({
  drawerOpen,
  handleClose,
  selectedOrder
}: OrderDrawerProps) => {
  const navigate = useNavigate()

  const planDetails = selectedOrder?.planDetails || {}
  const unitPrice = planDetails.baseplan.price
  const tableBodyContent = ([
    <>
      <TableCell key={`${planDetails.productName}`} align='left'>
        {planDetails.productName}
      </TableCell>
      <TableCell key={`${unitPrice.value}`} align='right'>
        {`${unitPrice.prefix} ${unitPrice.value.toFixed(2)}`}
      </TableCell>
      <TableCell key={`${selectedOrder.items[0].quantity}`} align='right'>
        {selectedOrder.items[0].quantity}
      </TableCell>
      <TableCell key={`${selectedOrder.price}`} align='right'>
        {`${unitPrice.prefix} ${selectedOrder.price.toFixed(2)}`}
      </TableCell>
    </>
  ])

  return (
    <Drawer onClose={() => handleClose()} open={drawerOpen} anchor='right'>
      <Box
        sx={{
          display: 'flex',
          gap: '1vw',
          width: '60vw',
          justifyContent: 'space-between'
        }}
      >
        <Stack
          direction='row'
          justifyContent='space-between'
          sx={{ margin: '48px', width: '90%' }}
        >
          <Box sx={{ width: '70%' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'flex-end',
                justifyContent: 'space-between'
              }}
            >
              <Typography variant='h4'>Purchase Order</Typography>
              <Typography variant='subtitle1'>
                {format(new Date(selectedOrder.createdAt), 'dd MMMM yyyy')}
              </Typography>
            </Box>
            <Divider sx={{ width: '100%' }} />
            <SimpleTable
              header=''
              tableHeaderCell={['Order Summary', 'Price', 'Quantity', 'Amount']}
              tableBodyCell={[tableBodyContent]}
            />
            <ColorBoxInfo>
              <>
                <Typography variant='note'>Validity: 1 month</Typography>
                <Typography variant='h5'>
                  Total: ${selectedOrder.price.toFixed(2)}
                </Typography>
              </>
            </ColorBoxInfo>
          </Box>
          <Stack>
            <Box>
              <Typography variant='h4' align='right'>Prepared For:</Typography>
            </Box>
            <Divider sx={{ width: '100%' }} />
            <Box>
              <Typography variant='h6' align='right'>{selectedOrder.userDetails.email}</Typography>
              <Typography variant='note' align='right'>{selectedOrder.orgDetails.name}</Typography>
            </Box>
          </Stack>
        </Stack>
        <Box>
          <IconButton onClick={() => handleClose()}>
            <HighlightOffIcon />
          </IconButton>
        </Box>
      </Box>
      {selectedOrder.status === 'BOOK DELIVERY' && (
        <Box sx={{ alignSelf: 'flex-end', marginRight: '32px' }}>
          <RoundedButton
            variant='filled'
            onClick={() =>
              navigate(`/app/book-delivery/${selectedOrder.orderNo}`)
            }
          >
            Book Delivery
          </RoundedButton>
        </Box>
      )}
    </Drawer>
  )
}

export default ViewOrderDrawer
